import EditDetailsForm from './EditDetailsForm'

export default EditDetailsForm
